








































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  AiReportExperimentCondition,
  DefaultAiReportExperimentCondition,
} from "#/model/admin/index";
import ExperimentConditionSelector from "@/components/ai/ExperimentConditionSelector.vue";
import ExperimentPatientSelector from "@/components/ai/ExperimentPatientSelector.vue";
import ExperimentResViewer from "@/components/ai/ExperimentResViewer.vue";

@Component({
  components: {
    ExperimentConditionSelector,
    ExperimentPatientSelector,
    ExperimentResViewer,
  },
})
/** お試し条件 */
export default class ExperimentCondition extends Vue {
  /** Prop */

  /** 利用画面 1:計画書 2:報告書 */
  @Prop({ default: 1 }) private viewType!: number;

  /** プロンプトテンプレート */
  @Prop({
    default: () => {
      DefaultAiReportExperimentCondition;
    },
  })
  private experimentCondition!: AiReportExperimentCondition;
}
